export enum HubloPoolDocumentType {
  CV = 'CV',
  DIPLOMA = 'DIPLOMA',
  CERTIFICATE_OF_COMPLETION = 'CERTIFICATE_OF_COMPLETION',
  IDENTITY_DOCUMENT = 'IDENTITY_DOCUMENT',
  IDENTITY_DOCUMENT_VERSO = 'IDENTITY_DOCUMENT_VERSO',
  RIB = 'RIB',
  VACCINATION_CERTIFICATE = 'VACCINATION_CERTIFICATE',
  CRIMINAL_RECORD = 'CRIMINAL_RECORD',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  RESIDENCE_PROOF = 'RESIDENCE_PROOF',
  SS_CERTIFICATE = 'SS_CERTIFICATE',
  HEALTH_CARD = 'HEALTH_CARD',
}
